import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Market } from './../model/market.interface';
import { MarketProxy } from './../proxy/market.proxy';

@Injectable({
  providedIn: 'root'
})
export class MarketService {
  constructor (private readonly marketProxy: MarketProxy) { }

  getAllMarkets(): Observable<Market[]> {
    return this.marketProxy.getMarkets();
  }
}
